import React from "react";
import heroImg from "../images/homepage/1.png";

import { Ticket } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";


export default function HeroNew() {
  const navigate = useNavigate();
  // user taken from useAuth but not used in this component currently
  useAuth();

  const handleBookingClick = () => {
    navigate("/booking");
  };

  return (
    <div className="hero-section">
      <div className="hero-content">
        <h4 className="!text-black" style={{ color: '#000000', fontWeight: 'bold', fontFamily: 'Inter, sans-serif' , fontSize: '2.5rem' }}>Professional <br /> Hair Care</h4>
        <p style={{ color: '#000000', fontWeight: '600' }}>
          Transform your hair with CALYX premium shampoo and conditioner collection. 
          Experience the ultimate revolution for your hair.
        </p>
        <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
          <button className="cta-button-hero" onClick={() => {
            const el = document.getElementById("products");
            if (el) el.scrollIntoView({ behavior: "smooth" });
          }}>
            Discover Collection
          </button>
          <button className="cta-button-hero" style={{ background: '#704214', display: 'flex', alignItems: 'center', gap: '10px' }} onClick={handleBookingClick}>
            <Ticket size={20} /> Book Tickets
          </button>
        </div>
      </div>
      <div className="hero-image-container">
        <img src={heroImg} alt="CALYX Hair Care" />
      </div>
    </div>
  );
}
